import { combineReducers } from "redux";
import { mask } from "./mask.reducer";
import { auth } from "./auth.reducer";
import { deliveryPackage } from "./deliveryPackage.reducer";
import { deliveryPackages } from "./deliveryPackages.reducer";
import { construction } from "./construction.reducer";
import { delegatePackages } from "./delegatePackages.reducer";
import { delegatePackage } from "./delegatePackage.reducer";
import { news } from "./news.reducer";
import { newsEdit } from "./newsEdit.reducer";
import { notifications } from "./notifications.reducer";
import { notification } from "./notification.reducer";
import { households } from "./households.reducer";
import { household } from "./household.reducer";
import { visitRecord } from "./visitRecord.reducer";
import { visitRecords } from "./visitRecords.reducer";
import { accessCard } from "./accessCard.reducer";
import { accessCards } from "./accessCards.reducer";
import { layout } from "./layout.reducer";
import { smartLockerPackages } from "./smartLockerPackages.reducer";
import { managementFees } from "./managementFees.reducer";
import { managementFee } from "./managementFee.reducer";
import { managementFeeBills } from "./managementFeeBills.reducer";

const rootReducer = combineReducers({
  mask,
  auth,
  deliveryPackage,
  deliveryPackages,
  construction,
  delegatePackages,
  delegatePackage,
  news,
  newsEdit,
  notifications,
  notification,
  households,
  household,
  visitRecord,
  visitRecords,
  accessCards,
  accessCard,
  layout,
  smartLockerPackages,
  managementFees,
  managementFee,
  managementFeeBills
  // ... todo
});

export default rootReducer;
